type Option = { label: string; value: string }

type Props = {
  label?: string
  value: string
  onChange: (value: string) => void
  options: Option[]
  disabled?: boolean
  error?: string | null
  hint?: string
  className?: string
}

export default function SelectField({
  label,
  value,
  onChange,
  options,
  disabled,
  error,
  hint,
  className,
}: Props) {
  return (
    <div className={className}>
      {label ? <label className="block text-sm mb-2">{label}</label> : null}
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="ds-input"
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      {error ? <div className="text-red-600 text-sm mt-2">{error}</div> : null}
      {!error && hint ? <div className="text-sm text-gray-500 mt-2">{hint}</div> : null}
    </div>
  )
}

